import { IconPropsType } from './icon-props'

export const LocationIcon = ({
  width = 28,
  height = 28,
  color
}: IconPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16.000000 16.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)"
        fill={color ?? '#D54300'}
        stroke="none"
      >
        <path
          d="M39 139 c-15 -15 -19 -28 -14 -47 6 -27 45 -92 55 -92 10 0 49 65 55
   92 8 31 -22 68 -55 68 -11 0 -29 -9 -41 -21z m65 -26 c4 -9 0 -23 -9 -32 -13
   -14 -17 -14 -30 0 -19 19 -10 49 15 49 10 0 21 -8 24 -17z"
        />
      </g>
    </svg>
  )
}
